import storage from '$common/utils/storage';
import languageUtils from '$common/utils/language';
import Toast from 'vant/es/toast/index'
import 'vant/es/toast/index.css'
import { uploadEventList } from "$common/utils/event-tracking/page";
import {
  currentUserExistUnpaidOrder
} from '$orderFood/api'

export default {
  data() {
    return {
      //第一次进入门店页增加未支付单的查询标识
      requestSign: false,
      userInfo: {},
      cartInfo: {},
      storeInfo: {},
      originMenuList: [],
      menuList: [],
      queryInfo: { tableName: '' }
    }
  },
  computed: {
    customerNo: () => storage.getItem('operatorNo'),
    isWownowApp: () => navigator.userAgent.toLowerCase().indexOf('wownow') !== -1,
    islocal() {
      return window.location.href.indexOf('localhost') !== -1
    },
    cacheKey() {
      return `ORDER-FOOD-CACHE`
    },
    lang() {
      if(this.$i18n?.locale){
        return this.$i18n.locale
      }
      const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
      return navigatorLanguage.indexOf('zh') !== -1 ? 'zh' : navigatorLanguage.indexOf('en') !== -1 ? 'en' : 'km';
    },
    langField() {
      const field = this.lang == 'zh' ? 'Zh' : this.lang == 'en' ? '' : 'Km'
      return field
    },
    showName() {
      return function (item) {
        return item['name' + this.langField] || item.name || item.nameKm || item.nameZh
      }
    },
    tableInfo() {
      let info = {
        storeNo: "MS1430090942563762176",
        tableId: "1106",
        tableName: ""
      }
      if (!this.islocal) {
        info = window?.ssrConfig?.routerConfig?.tableInfo ?? {}
      }
      return { ...info, ...this.queryInfo }
    },
    totalInfo() {
      const cartInfo = this.cartInfo || {}
      const keys = Object.keys(cartInfo)
      const result = {
        totalPrice: 0,
        totalNumber: 0
      }
      keys.forEach(key => {
        const target = cartInfo[key]
        if (target.selectNumber) {
          result.totalNumber += target.selectNumber
          let targetPrice = 0
          let subTexts = []
          const productSpecRespVOList = target.productSpecRespVOList || []
          const productPropertyVOList = target.productPropertyVOList || []
          productSpecRespVOList.forEach(specResp => {
            if (specResp.checked) {
              targetPrice += specResp.salePrice.amount
              subTexts.push(specResp['name' + this.langField])
            }
          })
          productPropertyVOList.forEach(item => {
            const propertySelectionVOList = item.propertySelectionVOList || []
            propertySelectionVOList.forEach(property => {
              if (property.checked) {
                targetPrice += property.additionalPrice.amount
                subTexts.push(property['name' + this.langField])
              }
            })
          })
          targetPrice = targetPrice * target.selectNumber
          this.$set(target, 'targetPrice', targetPrice)
          this.$set(target, 'subTexts', subTexts.join(' / '))
          result.totalPrice = result.totalPrice + targetPrice
        }
      })
      return result
    }
  },
  watch: {
    // 监听购物车数据变化改变cachedata
    cartInfo: {
      handler(newval, old) {
        this.setCacheData()
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.clearTimeOut()
    this.clearShopCartInvalidTime()
  },
  methods: {
    handlerSelectedCartInfo() {
      const cartInfo = storage.getItem(this.cacheKey)?.cartInfo || {}
      const storeInfo = storage.getItem(this.cacheKey)?.storeInfo || {}
      //只有当前进入的门店编号和本地缓存的门店编号相同时才取购物车数据
      console.log(cartInfo)
      if (Object.keys(cartInfo).length && (storeInfo?.storeNo == this.$root.tableInfo.storeNo || storeInfo?.storeNo == this.$route?.query?.tableId)) {
        const timer = setInterval(() => {
          if (this.menuList.length) {
            clearInterval(timer)
            this.$set(this, 'cartInfo', cartInfo);
            this.initCacheData()
          }
        }, 500)
      } else {
        this.cartInfo = {}
        this.setCacheData()
      }
    },
    handleMenuListSelectNumber(product, menuId, isDel) {
      const menu = this.menuList.find(i => i.id === menuId);
      const obj = {}
      Object.values(this.$root.cartInfo).forEach(i => {
        if (i.menuId == product.menuId && i.id == product.id) {
          obj[i.id + menuId] = (obj[i.id + menuId] || 0) + i.selectNumber
        }
      })
      Array.isArray(menu?.details) && menu.details.forEach((k, _index) => {
        if (product.id == k.id) {
          this.$set(menu.details[_index], 'selectNumber', isDel ? (0 + obj?.[product.id + menuId]) || 0 : obj[product.id + menuId])
        }
      })
    },
    async currentUserExistUnpaidOrder() {
      if (!(this.tableInfo?.tableId && this.tableInfo?.storeNo && !sessionStorage.getItem('requestSign'))) {
        console.log('已经调用过获取待支付的订单')
        return
      }
      const params = {
        customerNo: storage.getItem('operatorNo'),
        tableId: this.tableInfo.tableId,
        storeNo: this.tableInfo.storeNo,
        sessionId: storage.getItem('sessionId'),
        isLogin: String(!!storage.getItem('operatorNo'))
      }
      await currentUserExistUnpaidOrder(params, {
        success: (res) => {
          sessionStorage.setItem('requestSign', true)
          if (res?.hasUnPay) {
            this.$router.push({
              name: 'order-detail',
              query: {
                id: res?.orderIdList[0]
              }
            })
          }
        },
        fail: (e) => {
          console.log('currentUserExistUnpaidOrder query Error', e)
        }
      })
    },
    uploadEventList(params) {
      uploadEventList(params)
    },
    showToast(message, duration = 3000, isTop = false) {
      Toast({
        message,
        duration,
        position: isTop ? 'top' : 'middle'
      })
    },
    getField(product, menuId) {
      const productSpecRespVOList = product.productSpecRespVOList || []
      const productPropertyVOList = product.productPropertyVOList || []
      const productSpecRespIds = productSpecRespVOList.reduce((result, target) => {
        return result + (target.checked ? target.id : '')
      }, '')
      let productPropertyIds = ''
      productPropertyVOList.forEach(item => {
        const propertySelectionVOList = item.propertySelectionVOList || []
        productPropertyIds += propertySelectionVOList.reduce((result, target) => {
          return result + (target.checked ? target.id : '')
        }, '')
      })
      const key = ['key', product.id, String(menuId), productSpecRespIds, (productPropertyIds || '0')].join('-')
      return key
    },
    initWebviewSetting() {
      if (this.isWownowApp) {
        this.$root.timeout(() => {
          window?.WOWNOW?.enableWebViewGesture({ enable: 0 });
          window?.WOWNOW?.setWebViewBackStyle({ style: "goBack" });
        })
      }
    },
    getUserInfo(str = '') {
      return new Promise((resolve, reject) => {
        this.$root.timeout(() => {
          console.log('go get user info', this.isWownowApp, window?.WOWNOW?.getUserInfo)
          if (this.isWownowApp && window?.WOWNOW?.getUserInfo) {
            window.WOWNOW.getUserInfo({
              success: res => {
                if (res && res.loginName) {
                  storage.setItem('loginName', res.loginName)
                  storage.setItem('operatorNo', res.operatorNo)
                  this.userInfo.loginName = res.loginName;
                  this.userInfo.operatorNo = res.operatorNo;
                  resolve(res)
                }
              },
              fail: res => {
                console.log('get user info fail')
                window?.WOWNOW?.navigationToRoute({
                  route: `SuperApp://SuperApp/login`
                });
                // window?.WOWNOW.closeWindow()
                reject()
              }
            })
          } else {
            console.error('当前环境没有js sdk', storage.getItem('loginName'), storage.getItem('operatorNo'))
            if (str === 'checkout' && !storage.getItem('operatorNo')) {
              console.log('未登录')
              // 未登录 去到登录页
              if (process.env.NODE_ENV === 'development') {
                window.location.href = `/super/app/user/v1/index/login?callback=goOrderFood`
                return
              } else {
                window.location.href = `/mobile-h5/super/app/user/v1/login?callback=goOrderFood`
                return
              }
            } else {
              // zmy 浏览器的话就从storage里取值
              this.userInfo.loginName = storage.getItem('loginName') || '';
              this.userInfo.operatorNo = storage.getItem('operatorNo') || '';
              resolve()
            }
          }
        })
      })
    },
    initCacheData() {
      const keysObj = {}
      const cartInfo = this.$root.cartInfo || {}
      Object.keys(cartInfo).forEach(key => {
        const originalProduct = cartInfo[key]
        const field = `key-${originalProduct.id}-${originalProduct.menuId}`
        if (keysObj[field]) {
          cartInfo[key].originalProduct = keysObj[field]
        } else {
          keysObj[field] = originalProduct.originalProduct
        }
      })
      const menuList = this.$root.menuList || []
      menuList.forEach((menu) => {
        const details = menu.details || []
        details.forEach((product, index) => {
          if (keysObj[`key-${product.id}-${menu.id}`]) {
            details.splice(index, 1, keysObj[`key-${product.id}-${menu.id}`])
          }
        })
      })
    },
    setCacheData() {
      const cacheData = {
        userInfo: this.userInfo || {},
        cartInfo: this.cartInfo || {},
        storeInfo: this.storeInfo || {},
        menuList: this.menuList || [],
        queryInfo: this.queryInfo || { tableName: '' },
        originMenuList: this.originMenuList || []
      }
      // 能顶住把 5MB
      storage.setItem(this.cacheKey, cacheData)
    },
    removeCacheData() {
      storage.remove(this.cacheKey)
    },
    useCacheData() {
      const cacheData = storage.getItem(this.cacheKey)
      if (cacheData) {
        this.userInfo = cacheData.userInfo || {}
        this.cartInfo = cacheData.cartInfo || {}
        this.storeInfo = cacheData.storeInfo || {}
        this.menuList = cacheData.menuList || []
        this.queryInfo = cacheData.queryInfo || { tableName: '' }
        this.originMenuList = cacheData.originMenuList || []
        this.initCacheData()
      }
    }
  }
}
